import React, { createContext, useCallback, useMemo, useState } from 'react'
import { useAuth } from '@/contexts/AuthContext'

type ModeOptions = {
  ASBESTOS_CLICK: string[]
  ADD_POLYGON?: string[]
}

type AppCtx = {
  currentUser: any
  organizationId?: number | string | null
  municipalityId?: number | string | null
  // Map mode options for asbestos teledetection
  modeOptions: ModeOptions
  setModeOptions: React.Dispatch<React.SetStateAction<ModeOptions>>
  enterTeledetecionMode: (layer: any) => void
  exitTeledetecionMode: (layer: any) => void
}

const defaultModeOptions: ModeOptions = {
  ASBESTOS_CLICK: [],
  ADD_POLYGON: [],
}

const AppContext = createContext<AppCtx>({
  currentUser: null,
  modeOptions: defaultModeOptions,
  setModeOptions: () => {},
  enterTeledetecionMode: () => {},
  exitTeledetecionMode: () => {},
})

export default AppContext

export function AppProvider({ children }: { children: React.ReactNode }) {
  const { me } = useAuth()
  const [modeOptions, setModeOptions] = useState<ModeOptions>(defaultModeOptions)

  const enterTeledetecionMode = useCallback((layer: any) => {
    setModeOptions((prev) => ({
      ...prev,
      ASBESTOS_CLICK: [...prev.ASBESTOS_CLICK, layer.id],
    }))
  }, [])

  const exitTeledetecionMode = useCallback((layer: any) => {
    setModeOptions((prev) => ({
      ...prev,
      ASBESTOS_CLICK: prev.ASBESTOS_CLICK.filter((id) => id !== layer.id),
    }))
  }, [])

  const value = useMemo(
    () => ({
      currentUser: me,
      organizationId: (me as any)?.organization_id ?? null,
      municipalityId: (me as any)?.municipality_id ?? null,
      modeOptions,
      setModeOptions,
      enterTeledetecionMode,
      exitTeledetecionMode,
    }),
    [me, modeOptions, enterTeledetecionMode, exitTeledetecionMode]
  )

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}
